'use client'

import { CircledUserIcon } from '@repo/ui/CircledUserIcon'
import { useNavigate } from 'react-router-dom'
import { useNewClientStore } from '@repo/store/useNewClientStore'
import { useNotificationStore } from '@repo/store/useNotificationStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUIRadio from '@mui/material/Radio'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const NewMatterNotificationApprovalCOISSelect = ({ wideMode, handlePrevNext, updateStepState }) => {
  const { updateState } = useNewClientStore()
  const { isNewClient, setCOISSelect, coisSelect } = useNotificationStore()
  const navigate = useNavigate()

  const handleBackButtonClick = () => {
    handlePrevNext(-1)
  }

  const handleClickContinue = async () => {
    if (coisSelect === true) {
      if (isNewClient) {
        updateStepState({ status: 'completed', statusText: 'Complete' })
        navigate(`?wizard=COIS-NewMatter-NewClient-NotificationApproval&stage=conflict&step=introduction`)
        updateState({ key: 'isNew', value: true })
        setCOISSelect(true)
      } else {
        updateStepState({ status: 'completed', statusText: 'Complete' })
        navigate(`?wizard=COIS-NewMatter-NotificationApproval&stage=conflict&step=introduction`)
        setCOISSelect(true)
      }
    } else {
      if (isNewClient) {
        updateStepState({ status: 'completed', statusText: 'Complete' })
        navigate(`?wizard=NewMatter-NewClient-NotificationApproval&stage=client&step=client-details`)
        setCOISSelect(true)
      } else {
        updateStepState({ status: 'completed', statusText: 'Complete' })
        navigate(`?wizard=NewMatter-NotificationApproval&stage=matter&step=matter-details`)
        setCOISSelect(true)
      }
    }
  }

  return (
    <>
      <WizardPanel data-testid="NewMatterNotificationApprovalCOISSelect">
        <WizardFormSection>
          <WizardIconTitle
            title="Conflict of interest search"
            icon={CircledUserIcon}
            sx={{
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              mt: '0.25rem',
              ml: '0.5rem',
              mr: '0.5rem',
              [`& .MuiStack-root`]: {
                alignItems: 'center'
              }
            }}
          />
          <MUITypography variant="body1" sx={{ ml: '0.5rem', mr: '0.5rem' }}>
            Do you want to run a conflict of interest search for this client?
          </MUITypography>

          <MUIStack gap={4} direction="column" alignItems="flex-start" sx={{ width: '100%' }}>
            <MUIStack
              gap={0}
              direction="row"
              alignItems="center"
              sx={{ width: '100%', cursor: 'pointer' }}
              onClick={() => setCOISSelect(true)}
            >
              <MUIRadio
                checked={coisSelect === true}
                onChange={() => setCOISSelect(true)}
                value={true}
                name="radio-buttons"
                label="Yes, run a conflict of interest search (recommended)"
                inputProps={{ 'aria-label': 'Yes, run a conflict of interest search (recommended)' }}
              />
              <MUITypography
                variant="body1"
                sx={{ mb: '0.125rem', cursor: 'pointer' }}
                onClick={() => setCOISSelect(true)}
              >
                Yes, run a conflict of interest search (recommended)
              </MUITypography>
            </MUIStack>
            <MUIStack
              gap={0}
              direction="row"
              alignItems="center"
              sx={{ width: '100%', cursor: 'pointer' }}
              onClick={() => setCOISSelect(false)}
            >
              <MUIRadio
                checked={coisSelect === false}
                onChange={() => setCOISSelect(false)}
                value={false}
                label="No, do not run a conflict of interest search"
                name="radio-buttons"
                inputProps={{ 'aria-label': 'No, do not run a conflict of interest search' }}
              />
              <MUITypography
                variant="body1"
                sx={{ mb: '0.125rem', cursor: 'pointer' }}
                onClick={() => setCOISSelect(false)}
              >
                No, do not run a conflict of interest search
              </MUITypography>
            </MUIStack>
          </MUIStack>
        </WizardFormSection>
      </WizardPanel>
      <WizardFooter
        wideMode={wideMode}
        continueButtonText="Continue"
        backButtonVisible={true}
        handleClickBack={handleBackButtonClick}
        handleClickContinue={handleClickContinue}
      />
    </>
  )
}

NewMatterNotificationApprovalCOISSelect.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  updateStepState: PropTypes.func
}
